import { render, staticRenderFns } from "./restPasswords.vue?vue&type=template&id=0fd3c102&scoped=true&"
import script from "./restPasswords.vue?vue&type=script&lang=js&"
export * from "./restPasswords.vue?vue&type=script&lang=js&"
import style0 from "./restPasswords.vue?vue&type=style&index=0&id=0fd3c102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd3c102",
  null
  
)

export default component.exports